import { asCardFoil, CARD_FOIL_RANK, type CardFoilId } from '@shared/index'
import type { DeckSlot } from '../stores/deck'

export type PreviewCard = {
  id: string
  name: string
  foil: CardFoilId
}

const PREVIEW_COUNT = 5

/**
 * Highest-foil copies in a slot (main + extra), best print first.
 * Pads to 5 with nulls so the picker fan always has five frames.
 */
export function topFoilPreview(
  slot: DeckSlot,
  count: number = PREVIEW_COUNT,
): Array<PreviewCard | null> {
  const ranked = [...slot.mainDeckCards, ...slot.extraDeckCards]
    .map((card) => ({
      id: String(card?.id ?? ''),
      name: String(card?.name ?? ''),
      foil: asCardFoil(card?.foil),
      atk: Number(card?.atk) || 0,
    }))
    .filter((card) => card.id)
    .sort((a, b) => {
      const rank = CARD_FOIL_RANK[a.foil] - CARD_FOIL_RANK[b.foil]
      if (rank !== 0) return rank
      if (b.atk !== a.atk) return b.atk - a.atk
      return a.name.localeCompare(b.name)
    })
  const picked: Array<PreviewCard | null> = ranked
    .slice(0, count)
    .map(({ id, name, foil }) => ({ id, name, foil }))
  while (picked.length < count) picked.push(null)
  return picked
}
